import React, { Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import Layout from './components/common/Layout/Layout'
import Home from './pages/Home/Home'
import About from './pages/About/About'
import Portfolio from './pages/Portfolio/Portfolio'
import Contact from './pages/Contact/Contact'
import Tools from './pages/Tools/Tools'

// Lazy load blog components to reduce bundle size
const Blog = React.lazy(() => import('./pages/Blog/Blog'))
const BlogDetail = React.lazy(() => import('./pages/BlogDetail/BlogDetail'))

// The diary is lazy for a reason beyond bundle size: its crypto and LaTeX
// code should never load for a visitor who is just reading the portfolio.
const Diary = React.lazy(() => import('./pages/Diary/Diary'))

function App() {
  // Disable browser's automatic scroll restoration AGGRESSIVELY
  React.useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
    
    // Also try the alternative approach
    if (window.history && window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual'
    }
    
    console.log('🚫 Browser scroll restoration disabled')
  }, [])

  return (
    <ThemeProvider>
      <Router basename="/">
        <Suspense fallback={<div style={{padding: '2rem', textAlign: 'center'}}>Loading...</div>}>
          <Routes>
            {/* Full-screen, outside the site chrome, unlisted in the nav. */}
            <Route path="/diary" element={<Diary />} />
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/tools" element={<Tools />} />
                    <Route path="/contact" element={<Contact />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  )
}

export default App
